import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { Xoa } from "./Xoa";

export const BtnXoa = (TaiSanID) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Xoá"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
        <img src="/app-assets/images/icon-xoa-v2.png" />
        </PopoversBootrap>
      </a>
      <Xoa show={show} onHide={handleClose} TaiSanID={TaiSanID} />
    </>
  );
};
